import type { FaireProductEntity } from "../../entity_types/product";

export const atc_updated_fs_rec_3: FaireProductEntity = {
  token: "atc_updated_fs_rec_3",
  type: "product",
  name: "Bird of Paradise Bouquet in Vase",
  brandName: "Faire Source",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/028ebf88e25ba20465e575e1ac52abe01fd373ccbe7c3806aad3145a417aec95.webp",
  priceDollars: 52,
  msrpDollars: 65,
  description: "Recommended product for ATC flow.",
  tags: ["home", "design", "recommendations"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
